import Fraction from './fraction.js'
// import {Operation} from './base.js'

const zero = new Fraction(0);
const one = new Fraction(1);
const minus = new Fraction(-1);

function atom(f){
  let txt = f.toFraction();
  if(f.d != 1 || f.s < 0){
    txt = '( ' + txt + ' )';
  }
  return txt;
}

export class Term{
  constructor(val){
    this.root = false;
    this.num = 0;
    this.coeff = [];
    if(val != null){
      this.coeff.push(val);
    }
    this.terms = [];
    this.matrix = [];
  }
  get isNumber(){
    return this.terms.length == 0 && this.matrix.length == 0 && this.coeff.length == 1;
  }
  renumber(n){
    this.num=n;
    if(this.matrix.length > 0){
      this.num += 1;
    }
    for(const t of this.terms){
      this.num = t.renumber(this.num);
    }
    return(this.num);
  }
  size(n){
    if(this.matrix.length > 0){
      return this.num == n ? this.matrix.length : 0;
    }else{
      return this.terms.map( t => t.size(n) ).find( v => v>0 ) || 0;
    }
  }
  get canCalc(){
    if(this.coeff.length > 1 || ( this.coeff[0].equals(zero) && (this.matrix.length > 0 || this.terms.length > 0) ) ){
      return true;
    }
    if(this.terms.some( t => t.canCalc)){
      return true;
    }
    return this.terms.filter( t => t.isNumber ).length > 1 || this.terms.some( t => (t.isNumber && t.coeff[0].equals(zero)));
  }
  canDeg(n){
    if(this.matrix.length == 0){
      return this.terms.some( t => t.canDeg(n) );
    }else if(this.num != n){
      return false;
    }else{
      return this.matrix.length >= 2 &&
	(this.matrix.slice(1).every( row => row[0].equals(zero) ) ||
	 this.matrix[0].slice(1).every( e => e.equals(zero) ) );
    }
  }
  copyMatrix(){
    const m = [];
    for(const row of this.matrix){
      const newrow = [];
      for(const elem of row){
	newrow.push(elem);
      }
      m.push(newrow);
    }
    return m;
  }
  pushCoeff(c){
    if(this.coeff.length == 1 && (this.coeff[0].equals(one) || this.coeff[0].equals(minus) && c.s > 0 && c.n != 0)){
      this.coeff[0] = this.coeff[0].mul(c);
    }else{
      this.coeff.push(c);
    }
  }
  apply(op){
    const result = new Term(null);
    if(op.type == 'calc'){
      const iszero = this.coeff.some( e => e.equals(zero));
      const unit = (this.coeff.length == 1 && (this.coeff[0].equals(one) || this.coeff[0].equals(minus)));
      if(! iszero){
	result.matrix = this.copyMatrix();
      }
      let prod = new Fraction(1);
      for(const c of this.coeff){
	prod = prod.mul(c);
      }
      result.coeff.push(prod);
      if(this.terms.length > 0 && ! iszero){
	if(this.terms.some( t => t.canCalc )){
	  for(const t of this.terms){
	    if(! (t.isNumber && t.coeff[0].equals(zero)) ){
	      result.terms.push(t.apply(op));
	    }
	  }	  
	}else{	
	  let sum = new Fraction(0);
	  for(const t of this.terms){
	    if(t.isNumber){
	      sum = sum.add(t.coeff[0]);
	    }else{
	      result.terms.push(t);
	    }	  
	  }
	  if(result.terms.length == 0){
	    if(unit){
	      result.coeff[0] = result.coeff[0].mul(sum);
	    }else{
	      result.coeff.push(sum);
	    }
	  }else if(! sum.equals(zero)){
	    const newterm = new Term(sum);
	    result.terms.push(newterm);
	  }
	  if(result.terms.length == 1){
	    if(unit && result.terms[0].coeff.length == 1){
	      result.coeff[0] = result.coeff[0].mul(result.terms[0].coeff[0]);
	    }else{
	      for(const c of result.terms[0].coeff){
		result.coeff.push(c);
	      }
	    }
	    result.matrix = result.terms[0].matrix;
	    result.terms = [];	  
	  }
	}
      }
    }else{ // not calc
      for(const c of this.coeff){
	result.coeff.push(c.clone());
      }
      if(this.matrix.length == 0 || this.num != op.num){
	result.matrix = this.matrix;
	for(const t of this.terms){
	  result.terms.push(t.apply(op));
	}      
      }else{
	if(op.type == 'surrus'){
	  if(this.matrix.length < 2 || this.matrix.length > 3){
	    console.log('surrus: wrong size');
	    return null;
	  }
	  if(this.matrix.length == 2){
	    const t1 = new Term(one);
	    t1.coeff.push(this.matrix[0][0]);
	    t1.coeff.push(this.matrix[1][1]);
	    result.terms.push(t1);
	    const t2 = new Term(minus);
	    t2.coeff.push(this.matrix[0][1]);
	    t2.coeff.push(this.matrix[1][0]);
	    result.terms.push(t2);
	  }else{
	    for(let i=0;i<3;i++){
	      const t1 = new Term(one);
	      t1.coeff.push(this.matrix[0][i]);
	      t1.coeff.push(this.matrix[1][(i+1)%3]);
	      t1.coeff.push(this.matrix[2][(i+2)%3]);
	      result.terms.push(t1);	
	    }
	    for(let i=0;i<3;i++){
	      const t2 = new Term(minus);
	      t2.coeff.push(this.matrix[0][i]);
	      t2.coeff.push(this.matrix[1][(i+2)%3]);
	      t2.coeff.push(this.matrix[2][(i+1)%3]);
	      result.terms.push(t2);	
	    }      
	  }
	}else if(op.type == 'deg'){
	  if(this.matrix.length < 2 ||
	     ( this.matrix.slice(1).some( row => ! row[0].equals(zero) ) && 
	       this.matrix[0].slice(1).some( e => ! e.equals(zero) ) ) ){
	    console.log('cannot degenerate');
	    return(null);
	  }else if(this.matrix.length == 2){
	    result.pushCoeff(this.matrix[0][0]);
	    result.coeff.push(this.matrix[1][1]);
	    result.matrix = [];
	  }else{
	    result.pushCoeff(this.matrix[0][0]);
	    result.matrix = this.matrix.slice(1).map( row => row.slice(1) );
	  }	  
	}else if(op.type == 'expand'){
	  for(let k=0; k<this.matrix.length; k++){
	    const r = op.rc == 'row' ? op.expand_i : k;
	    const c = op.rc == 'col' ? op.expand_i : k;
	    const t = new Term( (r+c)%2 == 0 ? one : minus)
	    if(this.matrix[r][c].s > 0 && this.matrix[r][c].n != 0){
	      t.coeff[0] = t.coeff[0].mul(this.matrix[r][c]);
	    }else{
	      t.coeff.push(this.matrix[r][c]);
	    }
	    t.matrix = this.copyMatrix();
	    t.matrix.splice(r,1);
	    for(const row of t.matrix){
	      row.splice(c,1);
	    }
	    result.terms.push(t);
	  }
	}else if(op.type == 'mult'){
	  result.pushCoeff(op.coeff.inverse());
	  result.matrix = this.copyMatrix();
	  if(op.rc == 'row'){
	    for(let k=0; k<this.matrix.length; k++){
	      result.matrix[op.mult_i][k] = this.matrix[op.mult_i][k].mul(op.coeff);
	    }
	  }else{
	    for(let k=0; k<this.matrix.length; k++){
	      result.matrix[k][op.mult_i] = this.matrix[k][op.mult_i].mul(op.coeff);
	    }
	  }
	}else if(op.type == 'swap'){
	  result.coeff[0] = result.coeff[0].mul(minus);
	  result.matrix = this.copyMatrix();
	  if(op.rc == 'row'){
	    for(let k=0; k<this.matrix.length; k++){
	      result.matrix[op.swap_i1][k] = this.matrix[op.swap_i2][k];
	      result.matrix[op.swap_i2][k] = this.matrix[op.swap_i1][k];
	    }
	  }else{
	    for(let k=0; k<this.matrix.length; k++){
	      result.matrix[k][op.swap_i1] = this.matrix[k][op.swap_i2];
	      result.matrix[k][op.swap_i2] = this.matrix[k][op.swap_i1];
	    }
	  }
	}else if(op.type == 'add'){
	  result.matrix = this.copyMatrix();
	  if(op.rc == 'row'){
	    for(let k=0; k<this.matrix.length; k++){
	      result.matrix[op.add_i2][k] = this.matrix[op.add_i2][k].add(this.matrix[op.add_i1][k].mul(op.coeff));
	    }
	  }else{
	    for(let k=0; k<this.matrix.length; k++){
	      result.matrix[k][op.add_i2] = this.matrix[k][op.add_i2].add(this.matrix[k][op.add_i1].mul(op.coeff));
	    }
	  }
	}
      }
    }
    if(this.root){
      result.root = true;
      result.renumber(0);
    }
    return result;      
  }
  get tex(){
    let ar = [];
    let txt = ''
    if(this.coeff.length > 0 && this.coeff[0].s < 0){
      txt += ' - ';
    }
    if(this.isNumber || ! (this.coeff[0].equals(one) || this.coeff[0].equals(minus))){
      txt += atom(this.coeff[0].abs())
    }
    for(let i=1; i<this.coeff.length; i++){
      if(i != 1 || ! (this.coeff[0].equals(one) || this.coeff[0].equals(minus)) ){
	txt += ' \\times '
      }
      txt += atom(this.coeff[i])
    }
    if(txt.length > 0){
      ar.push(txt);
    }
    if(this.matrix.length > 0){
      ar.push('\\vmat{');
      for(let i=0;i<this.matrix.length; i++){
	const row=this.matrix[i];
	let txt = '';
	for(let j=0; j<row.length; j++){
	  if(j != 0){
	    txt += ' & ';
	  }
	  txt += row[j].toFraction();
	}
	if( i < this.matrix.length-1){
	  txt += ' \\\\';
	}
	ar.push(txt);
      }
      ar.push('}');
    }
    if(this.terms.length > 0){
      ar.push('\\left(');
      for(let n=0; n< this.terms.length; n++){
	if(n>0 && this.terms[n].coeff.length > 0 && this.terms[n].coeff[0].s > 0){
	  ar.push(' + ');
	}
	ar = ar.concat(this.terms[n].tex);
      }
      ar.push('\\right)');
    }
    return ar;
  }
}
